import React, { useContext } from "react";
import {
  Container,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Avatar,
  Chip,
  Checkbox,
} from "@mui/material";

import HealingIcon from "@mui/icons-material/Healing";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import NewspaperIcon from '@mui/icons-material/Newspaper';

import { AppContext } from "../Store";
import ChildImageGrid from "./ChildImageGrid";
import { Link } from "react-router-dom";
import theme from "../shared/theme";
import { getChildImageUrl } from "../imageUtils";

import { compareDesc, differenceInYears, parseISO } from "date-fns";

const TeachersPortal: React.FC = () => {
  const context = useContext(AppContext);
  const { childrenData, userContext } = context;
  // The accident and news forms are for the manager; `npm run dev` has no manager, so they show there too.
  const canAddManagerForms = !!userContext?.isAdmin() || import.meta.env.DEV;

  return (
    <Container
      maxWidth="lg"
      style={{
        display: "flex",
        justifyContent: "center",
      }}
    >
      {childrenData && (
        <Grid container spacing={3} justifyItems="center" justifyContent="center" justifySelf="center">
          <Grid item xs={10}>
            <ChildImageGrid data={childrenData} />
          </Grid>
          <Grid item xs={2}>
            <List sx={{ width: "100%", bgcolor: "background.paper" }}>
              {/* Native forms (replace the Google Forms; each has a "use the old form" fallback link). Accidents and news: manager only. */}
              {canAddManagerForms && (
                <Link to="/new/accident">
                  <ListItem>
                    <ListItemAvatar>
                      <HealingIcon color="primary" />
                    </ListItemAvatar>
                    <ListItemText primary="Accidents" secondary="&&nbsp;medication" />
                  </ListItem>
                </Link>
              )}

              <Link to="/new/observation">
                <ListItem>
                  <ListItemAvatar>
                    <PersonSearchIcon color="primary" />
                  </ListItemAvatar>
                  <ListItemText primary="Observations" />
                </ListItem>
              </Link>

              {canAddManagerForms && (
                <Link to="/new/news">
                  <ListItem>
                    <ListItemAvatar>
                      <NewspaperIcon color="primary" />
                    </ListItemAvatar>
                    <ListItemText primary="News" />
                  </ListItem>
                </Link>
              )}
            </List>
          </Grid>

          <Grid item xs={12}>

            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} size="small" aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell align="center" colSpan={5}>Morning</TableCell>
                    <TableCell align="center" colSpan={5}>Afternoon</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Child</TableCell>
                    <TableCell align="right">Mon</TableCell>
                    <TableCell align="right">Tue</TableCell>
                    <TableCell align="right">Wed</TableCell>
                    <TableCell align="right">Thu</TableCell>
                    <TableCell align="right">Fri</TableCell>
                    <TableCell align="right">Mon</TableCell>
                    <TableCell align="right">Tue</TableCell>
                    <TableCell align="right">Wed</TableCell>
                    <TableCell align="right">Thu</TableCell>
                    <TableCell align="right">Fri</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {childrenData
                    .sort((a, b) => compareDesc(parseISO(a.registration.childDateOfBirth), parseISO(b.registration.childDateOfBirth)))
                    .map((child) => (
                      <TableRow
                        key={child.id}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell component="th" scope="row">
                          <Chip
                            avatar={<Avatar alt={child.registration.name} src={getChildImageUrl(child.photoId, 'w250')} />}
                            size="small"
                            label={child.registration.childFirstName + " " + child.registration.childLastName}
                            variant="outlined"
                          />
                          {
                            differenceInYears(new Date(), new Date(child.registration.childDateOfBirth)) < 3 ? (
                              < Chip label="2yo" color="primary" size="small" />
                            ) : (
                              < Chip label="3yo" color="secondary" size="small" />
                            )
                          }
                        </TableCell>
                        <TableCell align="right" style={{ backgroundColor: theme.palette.action.hover }} >
                          <Checkbox disabled checked={child.registration.enrolment.monday.am} />
                        </TableCell>
                        <TableCell align="right" style={{ backgroundColor: theme.palette.action.hover }} >
                          <Checkbox disabled checked={child.registration.enrolment.tuesday.am} />
                        </TableCell>
                        <TableCell align="right" style={{ backgroundColor: theme.palette.action.hover }} >
                          <Checkbox disabled checked={child.registration.enrolment.wednesday.am} />
                        </TableCell>
                        <TableCell align="right" style={{ backgroundColor: theme.palette.action.hover }} >
                          <Checkbox disabled checked={child.registration.enrolment.thursday.am} />
                        </TableCell>
                        <TableCell align="right" style={{ backgroundColor: theme.palette.action.hover }} >
                          <Checkbox disabled checked={child.registration.enrolment.friday.am} />
                        </TableCell>
                        <TableCell align="right">
                          <Checkbox disabled checked={child.registration.enrolment.monday.pm} />
                        </TableCell>
                        <TableCell align="right">
                          <Checkbox disabled checked={child.registration.enrolment.tuesday.pm} />
                        </TableCell>
                        <TableCell align="right">
                          <Checkbox disabled checked={child.registration.enrolment.wednesday.pm} />
                        </TableCell>
                        <TableCell align="right">
                          <Checkbox disabled checked={child.registration.enrolment.thursday.pm} />
                        </TableCell>
                        <TableCell align="right">
                          <Checkbox disabled checked={child.registration.enrolment.friday.pm} />
                        </TableCell>

                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      )}
    </Container>
  );
};

export default TeachersPortal;
